import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { Login, ResponseResult } from '@models/authentication/login';
import { HttpBaseService } from '@service/http-base.service';
import { AuthService } from '@service/auth.sevice';
import { AuthTokenHelper } from '@helpers/auth-token-helper';
import { UserMenuAuth } from '@helpers/usermenuauth';
import { NgxSpinnerService } from "ngx-spinner";
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';
import { BeyondEMRHelper } from '@helpers/beyondemr-helper';
import { RoutingHelper } from '@helpers/routinghelper';

@Component({
    selector: 'app-two-way-auth',
    templateUrl: './two-way-auth.component.html',
    styleUrls: ['./two-way-auth.component.css']
})
export class TwoWayAuthComponent implements OnInit {
    login: Login;
    submitted = false;
    returnUrl: string;
    showValidation: boolean;
    public apiURL = null;
    hide = true;
    isRememberMe: boolean;
    IsDashboard: boolean = true;
    decryptedValue: string;
    api: string

    UserId: string;
    validaToken: string;
    inputToken: string;
    validToken: string;
    expiredVaidation: boolean;
    invalidToken: boolean;
    tokenExpiryTime: any;
    expiryTimeSec: any;
    timerCount: any;
    resendClicked: boolean = true;
    difference: any;

    constructor(
        private spinner: NgxSpinnerService,
        private router: Router,
        private httpService: HttpBaseService,
        private helper?: BeyondEMRHelper,
        private authHelper?: AuthTokenHelper,
        private authService?: AuthService,
        private usermenu?: UserMenuAuth,
    ) {
        this.login = new Login();
    }
    ngOnInit() {
        this.httpService.getAPIURL().subscribe(url => {
            this.api = url.API_URL;
            this.apiURL = `${url.API_URL}auth/GetTokenValidate`;
        });
        this.spinner.hide();
        this.UserId = atob(decodeURIComponent(localStorage.getItem("userSettingId")));
        this.validToken = localStorage.getItem("validToken");

    }

    ngAfterViewInit() {
        // get initial token expiry time from api
        let { tokenExpiredTime, tokenGeneratedTime } = JSON.parse(localStorage.getItem("loginObject"));
        var startMillis = new Date(tokenGeneratedTime).getTime();
        var endMillis = new Date(tokenExpiredTime).getTime();
        var timeDifference = endMillis - startMillis;
        var differenceInMinutes = timeDifference / (1000 * 60);
        this.difference = differenceInMinutes;

        // get saved time in storage
        let tokenTime = JSON.parse(localStorage.getItem("tokenTime"));
        let exp = localStorage.getItem("exp");

        if (exp) {
            return this.resendClicked = false;
        }

        // check if saved time in local then we use saved time in our states or use initial time.
        if (tokenTime) {
            this.tokenExpiryTime = (tokenTime.tokenExpiryTime ?? 0);
            this.expiryTimeSec = (tokenTime.expiryTimeSec);
        }
        else {
            this.tokenExpiryTime = (differenceInMinutes - 1);
            this.expiryTimeSec = 59;
        }

        // reverse counter logic
        setInterval(() => {
            if (this.resendClicked) {
                this.timerCount = `${(this.tokenExpiryTime > 0 ? this.tokenExpiryTime : '00') + ":" + (this.expiryTimeSec < 10 ? (0 + '' + this.expiryTimeSec) : this.expiryTimeSec)}`;
                this.expiryTimeSec--;
                localStorage.setItem("tokenTime", JSON.stringify({ expiryTimeSec: this.expiryTimeSec, tokenExpiryTime: this.tokenExpiryTime ?? 0 }));
                if (this.expiryTimeSec == 0) {
                    this.tokenExpiryTime--;
                    this.expiryTimeSec = 59;
                    localStorage.setItem("tokenTime", JSON.stringify({ expiryTimeSec: this.expiryTimeSec, tokenExpiryTime: this.tokenExpiryTime ?? 0 }));
                    // when the min equals 0 we stop the counter and remove the saved time in local storage
                    if (this.tokenExpiryTime < 0) {
                        this.resendClicked = false;
                        this.tokenExpiryTime = 0;
                        this.expiryTimeSec = 0;
                        this.timerCount = 0;
                        localStorage.removeItem("tokenTime");
                        localStorage.setItem("exp", "ok");
                    }
                }
            }
        }, 1000);
    }

    resendEmail() {
        this.spinner.show();
        let { userSettingId, username, domainname } = JSON.parse(localStorage.getItem("loginObject"));
        let [splitedName]: string[] = username.split("@");

        let url = `${this.api}auth/ResetToken?userSettingId=${userSettingId}&userName=${splitedName}&domainName=${domainname}`;
        this.httpService.postWithParameter(`${url}`).subscribe(response => {
            localStorage.removeItem("tokenTime");
            localStorage.removeItem("exp");
            localStorage.setItem("loginObject", JSON.stringify({ username: response.userName, userSettingId: response.userSettingId, userroleid: response.userRoleid, domainname: response.domainName, tokenGeneratedTime: response.tokenGeneratedTime, tokenExpiredTime: response.tokenExpiredTime }));
            window.location.reload();
        });
    }

    onSubmit(formElement: NgForm) {
        this.submitted = true;
        this.spinner.show();

        // stop here if form is invalid
        if (formElement.invalid) {
            this.showValidation = true;
            this.expiredVaidation = false;
            this.invalidToken = false;
            this.spinner.hide();
        }
        else {
            this.showValidation = false;
            this.paramData();
            this.spinner.hide();
        }
    }

    paramData() {
        let tokendata = JSON.parse(localStorage.getItem("loginObject"));
        let params = {
            userSettingId: parseInt(this.UserId),
            userName: tokendata?.username,
            domainName: tokendata?.domainname,
            token: this.inputToken,
            userRoleId: tokendata?.userroleid
        }
        this.validateLogin(params);
    }


    public validateLogin(params) {
        this.httpService.postWithParameter(`${this.apiURL}`, params).subscribe(response => {
            var result = response as ResponseResult;
            if (response.Status == "Invalid Token") {
                this.invalidToken = true;
                this.expiredVaidation = false;
            }
            if (response.Status == "Token Expired") {
                this.expiredVaidation = true;
                this.invalidToken = false;
            }
            if (result.Token) {
                this.authHelper.SetAuthorizationTokenValue(result.Token);
                var data = this.usermenu.SetUserMenu(result.UserMenu);
                var userToken = this.authService.getDecodedAccessToken(result.Token);
                localStorage.setItem("StatusId", result.User.StatusId);
                localStorage.setItem("PersonId", result.User.PersonId);
                localStorage.setItem("id", result.User.Id);
                localStorage.removeItem("tokenTime");
                localStorage.removeItem("exp");

                if (result.User.UserRoleId === BeyondEMRConstants.Role.Patient) {
                    let encryptedData = btoa(encodeURIComponent(response.User.PersonId));
                    localStorage.setItem("EncryptId", encryptedData);
                    if (userToken.IsAutogenerated === "True") {
                        this.router.navigate([`/authentication/patient-reset-password/`], {
                            queryParams: { user: this.login.UserName }
                        });
                    } else {
                        if (result.User.StatusId > 2) {
                            // let encodeId = this.routingHelper.EncodeParam(encryptedData);
                            this.router.navigate([`/patient-dashboard/${encryptedData}`]);
                        }
                        else {
                            //  let encodeId = this.routingHelper.DecodeParam(response.User.PersonId);
                            this.router.navigate([`/patients/patient/edit/${encryptedData}`])
                        }
                    }
                } else {
                    this.router.navigate(['/dashboard/main']);
                }
            }

            if (result) {
                this.showValidation = false;

            }
            else {
                this.showValidation = true;
                this.expiredVaidation = false;
                this.invalidToken = false;

            }
        }, error => {
            if ((error.status === 400 || error.status === 401) || (error.status === 401 && error.statusText == 'Unauthorized')) {
                this.showValidation = true;
                return false;
            }
            this.showValidation = true;
        });
    }
}
